import React from 'react';
import PropTypes from 'prop-types';
const find = require('lodash/find');
const filter = require('lodash/filter');
const forEach = require('lodash/forEach');
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');
const OrganizationMemberStore = require('../../stores/OrganizationMemberStore');
const OrganizationActions = require('../../actions/OrganizationActions');
import LoadingMainContent from '../loading/LoadingMainContent';
import UserTable from '../table/UserTable';
import UserRow from '../table/UserRow';
import AccessibleIcon from '../common/AccessibleIcon';
import OrganizationMemberEdit from './OrganizationMemberEdit';
import NewOrgMemberModal from '../modal/NewOrgMemberModal';
const StringUtil = require('../../../../app/shared/StringUtil');
const SortUtil = require('../../util/SortUtil');

const propTypes = {
    orgId: PropTypes.number.isRequired,
    userPermissions: PropTypes.object,
    backHandler: PropTypes.func
};

const defaultProps = {
    userPermissions: {},
    backHandler: null
};

class OrganizationMemberView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            organizationMemberStoreState: OrganizationMemberStore.getState(),
            showEditMemberViewId: null,
            modalState: {
                "newMember": false,
            },
            sort: {
                key: 'last_name',
                asc: true,
                type: 'string'
            },
            search_filter: ''
        }

        this.setMemberEditViewState = this.setMemberEditViewState.bind(this);
        this.setNewMemberModalState = this.setNewMemberModalState.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.unsubscribes = [OrganizationMemberStore.listen(this.onStoreChange.bind(this, "organizationMemberStoreState"))];
    }

    componentDidMount() {
        const actionID = uuid.v4();
        OrganizationActions.getMembers(actionID, { id: this.props.orgId });
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onStoreChange(storeStateName, state) {
        this.setState({ [storeStateName]: state });
    }

    setMemberEditViewState(collabId) {
        this.setState({
            showEditMemberViewId: collabId,
            modalState: { ...this.state.modalState, newMember: false },
        });
    }

    setNewMemberModalState(showBool) {
        this.setState({
            modalState: { ...this.state.modalState, newMember: showBool },
        });
    }

    sort(key, type) {
        let sortAsc;
        if (this.state.sort.key === key){
            sortAsc = !this.state.sort.asc;
        }
        else {
            sortAsc = true;
        }

        this.setState({
            sort: {
                key: key,
                asc: sortAsc,
                type: type
            }
        });
    }

    onFilterChange(e) {
        this.setState({
            search_filter: e.target.value,
        });
    }

    render() {
        if (!this.state.organizationMemberStoreState.members[this.props.orgId]) {
            return <LoadingMainContent />
        }

        if (this.state.showEditMemberViewId) {
            return (
                <OrganizationMemberEdit
                    heading={this.props.heading}
                    userPermissions={this.props.userPermissions}
                    backHandler={this.setMemberEditViewState.bind(this, null)}
                    orgId={this.props.orgId}
                    user={find(this.state.organizationMemberStoreState.members[this.props.orgId], { id: this.state.showEditMemberViewId })}
                />
            )
        }

        let sortOptions = {};
        if (this.state.sortKey === 'role_token') {
            sortOptions.preFormatFxn = StringUtil.getStringForRoleToken;
        }

        let orgMembers = this.state.organizationMemberStoreState.members[this.props.orgId];
        if (this.state.search_filter) {
            const filterBy = this.state.search_filter.toLowerCase();
            const size = orgMembers.length;
            const search_keys = ['email', 'first_name', 'last_name', 'display_name'];
            orgMembers = filter(orgMembers, (user) => {
                let matched = false;
                forEach(search_keys, (sk) => {
                    if (user[sk] && user[sk].toLowerCase().indexOf(filterBy) !== -1) {
                        matched = true;
                        return false;
                    }
                });
                return matched;
            });
        }

        const memberCount = orgMembers.length;
        const _sortedUsers = SortUtil.sortObjectArray(orgMembers, this.state.sort, sortOptions);

        return (
            <div>
                <div className="channelHeadingFlex">
                    <div className="channelHeadingFlex__heading">
                        { !!this.props.backHandler &&
                            <button
                                className="btn btn-primary glyph btn-circle btn-lg margin-right-15"
                                onClick={this.props.backHandler}
                                title={Strings['en'].common.BACK}
                            >
                                <AccessibleIcon label={Strings['en'].common.BACK}>
                                    <span className="fa fa-chevron-left" aria-hidden={true}/>
                                </AccessibleIcon>
                            </button>
                        }
                        <h2 className="heading-lg inline-block">{this.props.heading}</h2>
                    </div>
                    {this.props.userPermissions.inviteUser &&
                        <button
                            className="btn btn-primary glyph btn-circle btn-lg no-pad channelHeadingFlex__rightControl"
                            onClick={this.setNewMemberModalState.bind(this, true)}
                            title={Strings['en'].organization.NEW_MEMBER}
                        >
                            <AccessibleIcon label={Strings['en'].organization.NEW_MEMBER}>
                                <span className="fa fa-plus" aria-hidden={true} />
                                <span className="fa fa-user" aria-hidden={true} />
                            </AccessibleIcon>
                        </button>
                    }
                </div>

                <div className="tile-dash-floating">
                    <div className="margin-bottom-lg">
                        <input className="search" style={{marginLeft:'5px', marginRight:'5px'}} onChange={this.onFilterChange} placeholder={Strings['en'].common.SEARCH} />
                        <span className="font-weight-bold fr">{!!this.state.search_filter ? Strings['en'].organization.MATCHING_MEMBERS : Strings['en'].organization.MEMBERS}: {memberCount}</span>
                        <div className="float-clear" />
                    </div>

                    <UserTable
                        className="dark"
                        sortKey={this.state.sort.key}
                        sortAsc={this.state.sort.asc}
                        sortNameFxn={this.sort.bind(this, 'last_name', 'string')}
                        sortEmailFxn={this.sort.bind(this, 'email', 'string')}
                        sortRoleFxn={this.sort.bind(this, 'role_token', 'string')}
                        sortJoinDateFxn={this.sort.bind(this, 'join_date', 'date')}
                        sortActiveAtFxn={this.sort.bind(this, 'active_at', 'date')}
                    >
                        {_sortedUsers.map((user) =>
                            <UserRow
                                key={user.id}
                                user={user}
                                userRole={StringUtil.getStringForRoleToken(user.role_token)}
                                editFunction={this.setMemberEditViewState.bind(this, user.id)}
                            />
                        )}
                    </UserTable>
                </div>

                {this.state.modalState["newMember"] &&
                    <NewOrgMemberModal
                        show
                        closeHandler={this.setNewMemberModalState.bind(this, false)}
                        orgId={this.props.orgId}
                    />
                }
            </div>
        )
    }
}

OrganizationMemberView.propTypes = propTypes;
OrganizationMemberView.defaultProps = defaultProps;

export default OrganizationMemberView;